<template>
  <article class="article-workspace-item" v-if="workspace">
    <div class="workspace" :style="style">
      <input
        type="text"
        class="workspace-title"
        v-model="name"
        @blur="onNameChange"
      />
      <input
        type="color"
        class="workspace-color"
        v-model="color"
        @change="onColorChange"
      />
      <div class="users-container">
        <div class="user" v-for="(user, i) in users" :key="i">
          <p>{{ user.name }}</p>
          <!-- <button v-if="amIadmin" @click="removeUser(user.id)">
            <Icon icon="fas fa-times" />
          </button> -->
        </div>
      </div>
      <div class="buttons-container">
        <button class="invite" @click="invite()">
          <Icon icon="fas fa-share-alt" />
          <span>Inviter</span>
        </button>
        <button v-if="!amIadmin" class="quit" @click="quitWorkspace()">
          <Icon icon="fa fa-sign-out-alt" />
          <span>Quitter</span>
        </button>
        <button v-if="amIadmin" class="suppr" @click="deleteWorkspace()">
          <Icon icon="fa fa-trash" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import _ from 'lodash';
import * as fb from '../../firebase';
import WorkspaceShare from './WorkspaceShare.vue';
import workspaceService from '../../services/workspace.service';

export default {
  props: {
    workspace: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      color: '#000000',
      users: [],
      amIadmin: false,
      memory: {
        name: '',
        color: '',
      },
      snapshotUnsub: null,
    };
  },
  mounted() {
    this.getWorkspaceData();
  },
  destroyed() {
    this.unsubAll();
  },
  methods: {
    getWorkspaceData() {
      if (this.workspace) {
        this.name = _.get(this.workspace, 'name', '');
        this.color = _.get(this.workspace, 'color', '#000000');
        this.memory = {
          name: this.name,
          color: this.color,
        };

        if (_.includes(this.workspaceAdminsId, this.currentUserId)) {
          // Je suis admin de ce workspace
          this.amIadmin = true;
        }
        this.getUsers(this.workspace);
      }
    },
    getUsers() {
      this.snapshotUnsub = fb.usersCollection
        .where('workspaces', 'array-contains', this.workspaceRef)
        .onSnapshot((snapshot) => {
          snapshot.forEach((doc) => {
            const user = doc.data();
            user.id = doc.id;
            // On regarde si ce user est un admin de ce workspace
            user.isAdmin = _.includes(this.workspaceAdminsId, user.id);
            // Add if not already in
            if (_.findIndex(this.users, (u) => u.id === user.id) === -1) {
              this.users.push(user);
            }
          });
        });
    },
    unsubAll() {
      if (this.snapshotUnsub) {
        this.snapshotUnsub();
      }
    },

    onNameChange() {
      this.update('name');
    },
    onColorChange() {
      this.update('color');
    },
    update(field) {
      if (this[field] === this.memory[field]) {
        // Pas de changement
        return;
      }
      this.memory[field] = this[field];

      const obj = {};
      obj[field] = this[field];
      this.workspaceRef.update(obj).then(() => {
        this.$toasted.show('Modification effectuée.');
      });
    },
    removeUser(/* userId */) {
      // TODO
    },
    invite() {
      this.$modal.show(
        WorkspaceShare,
        {
          link: `/join/${this.workspaceId}`,
        },
        {
          height: 'auto',
        }
      );
    },
    quitWorkspace() {
      this.$confirm({
        message: `Quitter cet espace ?`,
        button: {
          no: 'Non',
          yes: 'Quitter',
        },
        callback: (confirm) => {
          if (confirm) {
            workspaceService
              .quitWorkspace(this.workspaceId, this.currentUserRef)
              .then(() => {
                this.$toasted.show('Espace quitté.');
              });
          }
        },
      });
    },
    deleteWorkspace() {
      this.$confirm({
        message: `Supprimer cet espace ? Il sera supprimé pour tous ses utilisateurs.`,
        button: {
          no: 'Non',
          yes: 'Supprimer',
        },
        callback: (confirm) => {
          if (confirm) {
            workspaceService
              .deleteWorkspace(this.workspaceId, this.currentUserId)
              .then(() => {
                this.$toasted.show('Espace supprimé.');
              });
            // Reload liste des workspaces TODO ?
            // this.$store.$dispatch('fetchUserProfile');
          }
        },
      });
    },
  },
  computed: {
    style() {
      return {
        borderLeft: `5px solid ${this.color}`,
      };
    },
    workspaceId() {
      return _.get(this.workspace, 'id', null);
    },
    workspaceRef() {
      if (this.workspaceId) {
        return fb.workspacesCollection.doc(this.workspaceId);
      }
      return null;
    },
    workspaceAdminsId() {
      return _.get(this.workspace, 'admins', []).map((user) => user.id);
    },
  },
  watch: {
    workspace() {
      // Si la parent change le workspace
      this.getWorkspaceData();
    },
  },
};
</script>

<style lang="scss" scoped src="./WorkspaceItem.scss"></style>
